// Eligibility API returns lowercase provider names — see
// Tenant/Domain/Payroll/Provider/PayrollPartnerSystemResolver::resolveForTenant
const AU_PROVIDERS: ReadonlyArray<string> = ['microkeeper', 'microkeeperbeta'];
const US_PROVIDERS: ReadonlyArray<string> = ['paycor'];
const UK_PROVIDERS: ReadonlyArray<string> = ['iris'];

export function isAUProvider(provider: string | undefined): boolean {
  if (!provider) {
    return false;
  }
  return AU_PROVIDERS.includes(provider.toLowerCase());
}

export function isUSProvider(provider: string | undefined): boolean {
  if (!provider) {
    return false;
  }
  return US_PROVIDERS.includes(provider.toLowerCase());
}

export function isUKProvider(provider: string | undefined): boolean {
  if (!provider) {
    return false;
  }
  return UK_PROVIDERS.includes(provider.toLowerCase());
}

// Set by the page header; read null-safely because unit tests have no __APP__.
function isDeputyXeroEmbed(): boolean {
  const integrations = window?.__APP__?.INTEGRATIONS as
    | { isDeputyXeroEmbed?: boolean }
    | undefined;
  return Boolean(integrations?.isDeputyXeroEmbed);
}

// Reads the server-rendered provider rather than the eligibility store, which
// screens such as the People list never load. The Xero embed keeps Xero's
// pay calendar wording even though its GB provider resolves to IRIS.
export function isUkPayrollAccount(): boolean {
  return (
    isUKProvider(window?.$dt?.objConfig?.PayrollProvider) &&
    !isDeputyXeroEmbed()
  );
}
